import { ESharedComponent } from "source/app/services/UI/State/ESharedComponent";
import { State } from "source/app/services/UI/State/State";
import { IDreamsState } from "../IDreamsState";


export function GetDreamRows() {
    const dreams = State.ReadClass<IDreamsState>(ESharedComponent.Dreams);

    if (!dreams) {
        return [];
    }

    const dreamRows = dreams.state.dreamsdata;
    return dreamRows;
}
